module.exports = "<div *ngIf=\"message\" [ngClass]=\"{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }\">\r\n\t<button type=\"button\" class=\"close\" (click)=\"clearAlert()\">\r\n\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t</button>\r\n\t{{message.text}}\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/global/_directives/alert/alert.component.html
// module id = ./src/app/global/_directives/alert/alert.component.html
// module chunks = 0